export const name = 'versionIndicator' as const
export const VersionIndicatorSymbol = Symbol('versionIndicator')
